export { default } from "./Login";



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/index.js